/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The expected reason for the difference; only unexpected blocks switching readers
 */
export enum CarrierComparisonCategory {
  COMBINED = 'combined',
  MANUAL_UNLINKED = 'manual-unlinked',
  PAYMENT_SUBSTRING = 'payment-substring',
  PAYMENT_STATE = 'payment-state',
  DEFAULT_ROW_EXPANDED = 'default-row-expanded',
  NAME_MISMATCH_FIXED = 'name-mismatch-fixed',
  UNEXPECTED = 'unexpected',
}
